module.exports = __webpack_public_path__ + "static/img/7-University-of-Edinburgh-Advanced-Care-Research-Centre.2337f258.jpg";